/**标记点**/
export const markers = [
  {
  id: 'new-marker1',
  position: {
    yaw:0.105 ,pitch: -0.302
  },
  // image: require('./../assets/adaptation.png'),
  image: require('./../assets/images/jinru2.gif'),
  size: {
      width: 60,
      height: 80
  },
  tooltip: {
      content: "内景",
      className: 'custom-tooltip',
      position: 'top',
      trigger: 'chan',
  },
},
{
  id: 'bowuguanNeijing',
  position: {
    yaw:6.277 ,pitch: -0.529
  },
  // image: require('./../assets/adaptation.png'),
  image: require('./../assets/images/jinru2.gif'),
  size: {
      width: 60,
      height: 80
  },
  tooltip: {
      content: "内景",
      className: 'custom-tooltip',
      position: 'top',
      trigger: 'chan',
  },
},
{
  id: 'huahaiNeijing',
  position: {
    yaw:5.685 ,pitch: -0.382
  },
  // image: require('./../assets/adaptation.png'),
  image: require('./../assets/images/jinru2.gif'),
  size: {
      width: 60,
      height: 80
  },
  tooltip: {
      content: "内景",
      className: 'custom-tooltip',
      position: 'top',
      trigger: 'chan',
  },
},
{
  id: 'new-marker3',
  tooltip: {
      content: "大棚1号",
      // content: '<img style="width:100px;height:100px;" src="https://fc1tn.baidu.com/it/u=671606946,449559851&fm=202&mola=new&crop=v1">'+
      // '<article><h2>种植作物：草莓</h2><p>棚号：1号大棚</p></article>',
      class: 'custom-tooltip',
      position: 'top',
      // trigger: 'click'
  },
  position: {
    yaw:0.165 ,pitch: -0.185
  },
  image: require('./../assets/weizhi.png'),
  size: {
      width: 48,
      height: 48
  },
  anchor: 'Holly',
},
{
  id: 'new-marker4',
  tooltip: {
      content: "大棚2号",
      class: 'custom-tooltip',
      position: 'top',
      // trigger: 'click'
  },
  position: {
    yaw:0.147 ,pitch: -0.196
  },
  image: require('./../assets/weizhi.png'),
  size: {
      width: 48,
      height: 48
  },
  anchor: 'Holly',
},
// {
// id: 'new-marker5',
// tooltip: {
//     content: "大棚3号",
//     class: 'custom-tooltip',
//     position: 'top',
//     // trigger: 'click'
// },
// position: {
//     yaw: '4.3',
//     pitch: '-0.593'
// },
// image: require('./../assets/weizhi.png'),
// size: {
//     width: 38,
//     height: 38
// },
// anchor: 'Holly',
// },
{
  id: 'marker_weather',
  tooltip: {
      content: "小型气象站",
      class: 'custom-tooltip',
      position: 'top',
      // trigger: 'click'
  },
  position: {
      // yaw: '3.1',
      // pitch: '-0.521'
      yaw:0.204 ,pitch: -0.167
  },
  image: require('./../assets/eqp/donghua3.gif'),
  size: {
      width: 98,
      height: 98
  },
  anchor: 'Holly',
},
{
    // polygon marker
    id: 'polygonBoliwenshi',
    polygon: [
        [6.098 ,-0.308], [6.007 ,-0.409], [0.289 ,-0.416], [0.226 ,-0.314]
    ],
    svgStyle: {
        fill: 'rgba(0, 254, 230,0)',
        stroke: 'rgba(0, 254, 254, 0.8)',
        strokeWidth: '5px',
    },
    tooltip: {
        content: '',
        class: 'custom-tooltip',
        position: 'bottom right',
    },
},
{
    // polygon marker
    id: 'polygonRiguang1',
    polygon: [
        [0.069 ,-0.193], [0.071 ,-0.312], [6.140 ,-0.308], [6.139 ,-0.280], [6.029 ,-0.253], [6.065 ,-0.231], [6.114 ,-0.221]
    ],
    svgStyle: {
        fill: 'rgba(0, 254, 230,0)',
        stroke: 'rgba(0, 254, 254, 0.8)',
        strokeWidth: '3px',
    },
    tooltip: {
        content: '',
        class: 'custom-tooltip',
        position: 'bottom right',
    },
},
{
    // polygon marker
    id: 'polygonRiguang2',
    polygon: [
        [0.091 ,-0.181], [0.297 ,-0.175], [0.352 ,-0.197], [0.279 ,-0.202], [0.248 ,-0.219], [0.259 ,-0.238], [0.309 ,-0.247], [0.382 ,-0.263], [0.327 ,-0.279], [0.336 ,-0.306], [0.122 ,-0.308]
    ],
    svgStyle: {
        fill: 'rgba(0, 254, 230,0)',  
        stroke: 'rgba(0, 254, 254, 0.8)',
        strokeWidth: '3px',
    },
    tooltip: {
        content: '',
        class: 'custom-tooltip',
        position: 'bottom right',
    },
},
{
    id: 'polygonGuangai',
    polygon: [
        [0.234 ,-0.313], [0.264 ,-0.364], [0.344 ,-0.360], [0.305 ,-0.307]
    ],
    svgStyle: {
        fill: 'rgba(243, 152, 88, 0)',
        stroke: 'rgba(0, 254, 254, 0.8)',
        strokeWidth: '3px',
    },
    tooltip: {
        content: '',
        class: 'custom-tooltip',
        position: 'bottom right',
    },
},
{
    id: 'polygonHuahai',
    polygon: [
        [5.911 ,-0.280], [5.541 ,-0.343], [5.680 ,-0.442], [5.879 ,-0.358], [6.072 ,-0.292]
    ],
    svgStyle: {
        fill: 'rgba(0, 254, 230,0)',
        stroke: 'rgba(0, 254, 254, 0.8)',
        strokeWidth: '3px',
    },
    tooltip: {
        content: '',
        class: 'custom-tooltip',
        position: 'bottom right',
    },
},
{
  // html marker with custom style
  id: 'polygonText1',
  position: { yaw:6.283 ,pitch: -0.369 },
  html: '<b>玻璃温室</b>',
  anchor: 'bottom right',
  scale: [0.5, 1.5],
  style: {
      // maxWidth: '100px',
      color: 'white',
      fontSize: '36px',
      fontFamily: 'Helvetica, sans-serif',
      textAlign: 'center',
  },
},
{
  id: 'polygonText2',
  position: { yaw:6.242 ,pitch: -0.236 },
  html: '日光温室',
  anchor: 'bottom right',
  scale: [0.5, 1.5],
  style: {
      // maxWidth: '100px',
      color: 'white',
      fontSize: '36px',
      fontFamily: 'Helvetica, sans-serif',
      textAlign: 'center',
  },
},
{
  id: 'polygonText3',
  position: { yaw:0.239 ,pitch: -0.231 },
  html: '日光温室',
  anchor: 'bottom right',
  scale: [0.5, 1.5],
  style: {
      // maxWidth: '100px',
      color: 'white',
      fontSize: '36px',
      fontFamily: 'Helvetica, sans-serif',
      textAlign: 'center',
  },
},
{
  id: 'polygonText4',
  position: {yaw:0.099 ,pitch: -0.305},
  html: '玻<br>璃<br>连<br>廊',
  anchor: 'bottom right',
  scale: [0.5, 1.5],
  style: {
      // maxWidth: '100px',
      color: 'white',
      fontSize: '26px',
      fontFamily: 'Helvetica, sans-serif',
      textAlign: 'center',
  },
},
{
  id: 'polygonText5',
  position: { yaw:0.318 ,pitch: -0.345 },
  html: '灌溉系统',
  anchor: 'bottom right',
  scale: [0.5, 1.5],
  style: {
      // maxWidth: '100px',
      color: 'black',
      fontSize: '26px',
      fontFamily: 'Helvetica, sans-serif',
      textAlign: 'center',
  },
},
{
  id: 'polygonText6',
  position: { yaw:5.846 ,pitch: -0.353 },
  html: '露天花海',
  anchor: 'bottom right',
  scale: [0.5, 1.5],
  style: {
      color: 'white',
      fontSize: '36px',
      fontFamily: 'Helvetica, sans-serif',
      textAlign: 'center',
  },
},
];
/**全景图片列表**/
export const photos = [
  {
  id: 'sphere',
  panorama:require('./../assets/DJI_0082.jpg'),
  thumbnail: require('./../assets/DJI_0082.jpg'),
  options: {
      caption: '北国之春全景',
  },
  markers:markers
},
{
  id: 'sphere-test',
  panorama: require('./../assets/温室内2.jpg'),
  thumbnail: require('./../assets/温室内2.jpg'),
  name: '北国之春内景',    options: {
      caption: '北国之春内景',
  },
  markers:[{
      id: 'new-marker21',
      position: {
          yaw: '57deg',
          pitch: '0deg'
      },
      image: require('./../assets/images/jinru2.gif'),
      size: {
          width: 60,
          height: 80
      },
      tooltip: {
          content: "外景",
          className: 'custom-tooltip',
          position: 'top',
          trigger: 'chan',
      },
  },]
},
{
  id: 'sphere-test',
  panorama: require('./../assets/草莓博物馆进门大厅.jpg'),
  thumbnail: require('./../assets/草莓博物馆进门大厅.jpg'),
  name: '草莓博物馆大厅里侧东侧方',    options: {
      caption: '草莓博物馆大厅里侧东侧方',
  },
  markers:[{
      id: 'new-marker21',
      position: {
        yaw:3.094 ,pitch: -0.184
      },
      image: require('./../assets/images/jinru2.gif'),
      size: {
          width: 60,
          height: 80
      },
      tooltip: {
          content: "外景",
          className: 'custom-tooltip',
          position: 'top',
          trigger: 'chan',
      },
  },]
},
{
  id: 'sphere-test',
  panorama: require('./../assets/院内花海.jpg'),
  thumbnail: require('./../assets/院内花海.jpg'),
  name: '院内花海',    options: {
      caption: '院内花海',
  },
  markers:[{
      id: 'new-marker21',
      position: {
        yaw:3.094 ,pitch: -0.184
      },
      image: require('./../assets/images/jinru2.gif'),
      size: {
          width: 60,
          height: 80
      },
      tooltip: {
          content: "外景",
          className: 'custom-tooltip',
          position: 'top',
          trigger: 'chan',
      },
  },]
},
// {
//     id: 'key-biscayne',
//     panorama: require('./../assets/dadi2.jpg'),
//     thumbnail: require('./../assets/dadi2.jpg'),
//     name: 'Key Biscayne',
//     options: {
//         caption: '图三',
//     },
//     markers:[ ]
// },
]